import { Experiment } from '@naturalcycles/shared'
import { QuizSignatureObject } from '@src/app/core/services/quiz/quiz.service'
import { QuizModifier } from '@src/app/core/util/quiz.util'
import { AnyPage } from '@src/app/shared/typings/enum/pages'
import { Breakpoint, Sections } from '@src/app/shared/typings/enum/quiz'
import { SignupQuizFlow, WSQuizEngineConfig } from '@src/app/shared/typings/interfaces/quiz'
import { getAb396ConceiveTimingBreakpointAction, getAb396GoalBreakpointAction } from './ab-396'

class Exp396Quiz implements QuizModifier<WSQuizEngineConfig> {
  public _shouldEnhance(obj: QuizSignatureObject): boolean {
    return obj.experiment[Experiment.WS_COUNTRY_CERTIFICATIONS] === 'test'
  }

  public enhanceEngineConfig(
    obj: QuizSignatureObject,
    config: WSQuizEngineConfig,
  ): WSQuizEngineConfig {
    if (!this._shouldEnhance(obj)) return config
    const goal = config.breakpointActions[Breakpoint.goal]
    config.breakpointActions[Breakpoint.goal] = getAb396GoalBreakpointAction(goal)
    const conceiveTiming = config.breakpointActions[Breakpoint.conceiveTiming]
    config.breakpointActions[Breakpoint.conceiveTiming] =
      getAb396ConceiveTimingBreakpointAction(conceiveTiming)
    return config
  }

  public enhanceSections(obj: QuizSignatureObject, sections: Sections): Sections {
    if (!this._shouldEnhance(obj)) return sections
    return sections
  }

  public enhanceInitialFlow(obj: QuizSignatureObject, flow: SignupQuizFlow): any {
    if (!this._shouldEnhance(obj)) return flow
    return flow
  }

  public enhanceEntry(obj: QuizSignatureObject, entry: AnyPage[] | null): AnyPage[] | null {
    if (!this._shouldEnhance(obj)) return entry
    return entry
  }

  public enhanceExit(obj: QuizSignatureObject, exit: AnyPage[] | null): AnyPage[] | null {
    if (!this._shouldEnhance(obj)) return exit
    return exit
  }
}

export const exp396Quiz = new Exp396Quiz()
